import { Component } from 'react';
import Helmet from 'react-helmet';

import Icon from 'react-fa';

import { titles } from '../data';

class NotFound extends Component {
  render() {
    return (
      <div className="not-found">
        <Icon name="question" />
        <Helmet title={titles.notFound} titleTemplate={titles.titleTemplate} />
        <p>お探しのページが見つかりませんでした。</p>
      </div>
    )
  }
}

export default NotFound;



/** WEBPACK FOOTER **
 ** ./src/components/NotFound.js
 **/